import { inject, Injectable } from '@angular/core';
import { ApiServices, ApiExecutorService } from '@ddv/http';
import { FastnessQuery, FastnessResponse, DdvDate } from '@ddv/models';
import { FuzzyDate } from '@hs/ui-core-date';
import { Observable } from 'rxjs';

@Injectable()
export class DataFastnessService {
    private readonly trebekApiExecutor = inject<ApiExecutorService>(ApiServices.trebek);

    checkFastness(
        clientCode: string,
        dateFrom: string | undefined,
        dateTo: string | undefined,
        queryType: string,
        fuzzyDates: FuzzyDate[],
    ): Observable<FastnessResponse> {
        const requestBody: FastnessQuery = constructFastnessCheckBody(dateFrom, dateTo, queryType, fuzzyDates);
        return this.trebekApiExecutor.invokeServiceWithBody(clientCode, '/fastness/', 'POST', requestBody);
    }
}

function constructFastnessCheckBody(
    dateFrom: string | undefined,
    dateTo: string | undefined,
    queryType: string,
    fuzzyDates: FuzzyDate[],
): FastnessQuery {
    const startDate = getValidDate(dateFrom, fuzzyDates)?.toReversePaddedDashFormat();
    const endDate = getValidDate(dateTo, fuzzyDates)?.toReversePaddedDashFormat();
    return {
        timeseriesRange: {
            granularity: 'none',
            startDate,
            endDate,
        },
        queryTypes: [queryType],
    };
}

function getValidDate(date = '', fuzzyDates?: FuzzyDate[]): DdvDate {
    return DdvDate.isStringValidDate(date) ?
        DdvDate.fromUSFormat(date) :
        (getDateFromFuzzy(date, fuzzyDates) ?? DdvDate.empty);
}

function getDateFromFuzzy(fuzzyDate: string, fuzzyDates?: FuzzyDate[]): DdvDate | undefined {
    const option = fuzzyDates?.find((fd) => fd.name.toLocaleUpperCase() === fuzzyDate?.toLocaleUpperCase());
    return option ? DdvDate.fromISOFormat(option.value) : undefined;
}
